if (!customElements.get('custom-cart-total')) {
    class CustomCartTotal extends HTMLElement {
        constructor() {
            super();
            this.taxRules = [];
        }

        connectedCallback() {
            this.init();
        }

        async init() {
            this.taxRules = await window.CustomTaxRules.getTaxRules(this.getAttribute('data-country-code'));
            this.updateTotal();
        }

        updateTotal() {
            const itemsData = this.getAttribute('data-items');
            const taxExempt = this.getAttribute('data-tax-exempt');
            const total = window.CustomUtilities.calculateCartTotal(itemsData, this.taxRules, taxExempt);

            this.textContent = window.CustomNumberFormatters.formatPrice(total);;
        }
    }

    customElements.define('custom-cart-total', CustomCartTotal);
}
